export function buildRouteMeta (route) {
  const source = route || {}
  const sourceMeta = source.meta || {}
  const requiredActions = sourceMeta.requiredActions !== undefined
    ? sourceMeta.requiredActions
    : source.required_actions
  const actionMatchMode = sourceMeta.actionMatchMode !== undefined
    ? sourceMeta.actionMatchMode
    : source.action_match_mode
  const meta = {
    title: source.title,
    icon: source.icon,
    hidden: source.hidden,
    keepAlive: source.keep_alive,
    rootOnly: Boolean(sourceMeta.rootOnly)
  }
  if (requiredActions !== undefined) meta.requiredActions = requiredActions
  if (actionMatchMode !== undefined) meta.actionMatchMode = actionMatchMode
  return meta
}



// WEBPACK FOOTER //
// ./src/store/modules/route-meta.js